import { ToothSurface } from '../../../../graphql/graphql';

export const ALL_TOOTH_SURFACES: ToothSurface[] = [
	ToothSurface.CervicalBuccal,
	ToothSurface.Buccal,
	ToothSurface.Mesial,
	ToothSurface.Incisal,
	ToothSurface.Distal,
	ToothSurface.BuccalCusp,
	ToothSurface.Occlusal,
	ToothSurface.Lingual,
	ToothSurface.CervicalLingual,
	ToothSurface.BuccalSurface,
	ToothSurface.LingualSurface,
	ToothSurface.DistoBuccalCusp,
	ToothSurface.MesioBuccalCusp,
	ToothSurface.CervicalPalatal,
	ToothSurface.Class_4Distal,
	ToothSurface.Class_4Mesial,
	ToothSurface.Palatal,
	ToothSurface.PalatalCusp,
	ToothSurface.PalatalSurface,
	ToothSurface.MesioPalatalCusp,
	ToothSurface.DistoPalatalCusp,
	ToothSurface.MesioLingualCusp,
	ToothSurface.DistoLingualCusp,
	ToothSurface.LingualCusp,
];
